<template>
  <div class="py-5" v-if="loaded">
    <!-- rendering -->
    <div class="w-full bg-gray-700 text-white rounded-t">
      <h2 class="text-center py-1">{{ i18n.currently_rendering }}</h2>
    </div>
    <transition name="vue-fade" mode="out-in">
      <div v-if="rendering !== undefined">
        <template v-for="project in rendering">
          <user-project
            v-if="project.owned"
            class="border-b border-gray-100"
            :key="project.id"
            :data="project"
            :bgblue="false"
            :i18n="i18n.project"
          />
          <anonym-project
            v-else
            :key="project.id"
            :project="project"
            :rendering="true"
          />
        </template>
      </div>
      <div
        class="text-gray-800 text-xs text-center py-5"
        v-else
        v-text="i18n.nothing_rendering"
      ></div>
    </transition>

    <!-- queued -->
    <div class="w-full bg-gray-600 text-white rounded-t mt-5">
      <h2 class="text-center py-1">{{ i18n.queued }}</h2>
    </div>
    <transition name="vue-fade" mode="out-in">
      <div class="" v-if="queued !== undefined">
        <template v-for="project in queued">
          <user-project
            v-if="project.owned"
            class="border-b border-gray-100"
            :key="project.id"
            :data="project"
            :bgblue="false"
            :i18n="i18n.project"
          />
          <anonym-project
            v-else
            :key="project.id"
            :project="project"
            :rendering="false"
          />
        </template>
      </div>
      <div
        class="text-gray-800 text-xs text-center py-5"
        v-else
        v-text="i18n.nothing_queued"
      ></div>
    </transition>
  </div>
  <div class="flex justify-center p-5" v-else>
    <loading></loading>
  </div>
</template>

<script>
import AnonymProject from "./AnonymProject";
import UserProject from "../Project";
export default {
  components: { AnonymProject, UserProject },
  props: {
    loaded: Boolean,
    i18n: Object,
    rendering: Array,
    queued: Array,
  },
};
</script>
